export default [
  {
    title: '序号',
    dataIndex: 'index',
    key: 'index',
    customRender: (value, item, index) => {
      return index + 1
    },
  },
  {
    title: '名称',
    dataIndex: 'name',

  },
  {
    title: '活动价',
    dataIndex: 'price',

  },
  {
    title: '原价',
    dataIndex: 'ori_price',
  },
  {
    title: '赠送天数',
    dataIndex: 'h_date',
  },
  {
    title: '会员天数',
    dataIndex: 'e_date',
  },
  {
    title: '会员金额',
    dataIndex: 'c_amt',
  },
  {
    title: '持股个数',
    dataIndex: 'c_num',
  },
  {
    title: '策略描述',
    dataIndex: 'content',
  },
  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
    width: '256px'
  },
]